import React, { Component } from "react";
import PlansForm from "../PlansForm/PlansForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : PlansPage
Description : Componente que contienen el formulario de la pantalla Plans
Date Autor Modification
================================================================================
06/10/2023 Santiago Coca – Se llama al componente PlansForm
================================================================================ */
class PlansPage extends Component {
    render() {
        return (
            <div>
                <PlansForm />
            </div>
        )
    }
}

export default PlansPage;